import {
  CircularProgress,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Stack,
  useMediaQuery,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import navlogo from "../../assets/KHT Nav Logo.svg";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useForm } from "react-hook-form";
import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Dialog from "@mui/material/Dialog";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownHeight, setDropdownHeight] = useState(0);

  const toggleBox = () => {
    if (isOpen) {
      setIsOpen(false);
      window.location.reload();
    } else {
      setIsOpen(true);
    }
  };

  const [openDropdown, setOpenDropdown] = useState(false);
  const handleClickDropdown = () => {
    setOpenDropdown((prev) => !prev);
  };

  const [openDropdownCity, setOpenDropdownCity] = useState(false);
  const handleClickDropdownCity = () => {
    setOpenDropdownCity((prev) => !prev);
  };

  useEffect(() => {
    if (isOpen) {
      setDropdownHeight(document.getElementById("dropdownContent").Height);
    } else {
      setDropdownHeight(0);
    }
  }, [isOpen]);
  const handleCloseDropdown = () => {
    setOpenDropdown(false);
  };
  const [openDropdownNew, setOpenDropdownNew] = useState(false);

  const handleClickDropdownNew = () => {
    setOpenDropdownNew((prev) => !prev);
  };

  const handleCloseDropdownNew = () => {
    setOpenDropdownNew(false);
  };

  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const [Menu, setMenu] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };

  const themeColors = ["#ff5733", "#3498db", "#2ecc71"];

  const handleCloseNew = () => {
    setOpenNew(false);
  };

  const [otpNew, setOtpNew] = useState("");
  const handleChangeOtpNew = (NewValue) => {
    setOtpNew(NewValue);
  };

  const [openOtpNew, setOpenOtpNew] = useState(false);

  const handleOpenotpNew = () => {
    setOpenOtpNew(true);
  };

  const handleCloseOtpNew = () => {
    setOpenOtpNew(false);
  };

  const menuRef = useRef(null);
  const toggleMenu = () => {
    setMenu((prevOpen) => !prevOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const [smsIdNew, setSmsIdNew] = useState(null);
  const [studentQueryFormData, setStudentQueryFormData] = useState(null);
  const navigate = useNavigate();
  const schema = yup.object().shape({
    email: yup.string().email().required(),
    fullName: yup.string().required(),
    pincode: yup.string().required(),
    area: yup.string().required(),
    city: yup.string().required(),
    mobileNumber: yup.string().required(),
    subject: yup.string().required(),
    course: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      classMode: "1",
    },
  });

  const [selectedColor, setSelectedColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const onSubmitHandler = async (data) => {
    setOtpNew("");
    setLoading(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      date
    );
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      hour12: false,
    }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
      date
    );
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
      date
    );
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("area", data.area);
    formData.append("fullName", data.fullName);
    formData.append("pincode", data.pincode);
    formData.append("course", data.course);
    formData.append("subject", data.subject);
    formData.append("classMode", data.classMode);
    formData.append("city", data.city);
    formData.append("mobile", data.mobileNumber);
    formData.append("token", CurrentDateTime);
    formData.append("smsType", "generalQuery");
    setStudentQueryFormData(formData);

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/notifySMS",
        formData,
        config
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        setLoading(false);
        setOpenOtpNew(true);
        setOpen(false);
        setSmsIdNew(response.data.data.smsID.toString());
        reset();
      } else {
        toast.warning(response.data.message ?? "Something Went Wrong");
        setLoading(false);
      }
    } catch (error) {
      toast.error(
        error?.response.data.message ?? "An error occurred. Please try again."
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * themeColors.length);
    setSelectedColor(themeColors[randomIndex]);
  }, []);

  const handleResendOtpNew = async (e) => {
    e.preventDefault();
    setLoading2(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      date
    );
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      hour12: false,
    }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
      date
    );
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
      date
    );
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const tempFormData = new FormData();
    tempFormData.append("smsId", smsIdNew);
    tempFormData.append("mobile", studentQueryFormData.get("mobile"));
    tempFormData.append("smsType", "generalQuery");
    tempFormData.append("token", CurrentDateTime);

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/resendOTP",
        tempFormData
      );

      if (response.data.success.toString() === "true") {
        toast.success(response.data.message);
        setSmsIdNew(response.data.data.smsID.toString());
        setLoading2(false);
      } else {
        toast.error(response.data.message);
        setLoading2(false);
      }
    } catch (error) {}
  };

  const handleSubmitOtpNew = async (e) => {
    e.preventDefault();
    setLoading(true);

    let date = new Date();
    let randomnumber = Math.floor(Math.random() * 1000000);
    let year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
      date
    );
    let day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    let hours = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      hour12: false,
    }).format(date);
    let minutes = new Intl.DateTimeFormat("en", { minute: "2-digit" }).format(
      date
    );
    let seconds = new Intl.DateTimeFormat("en", { second: "2-digit" }).format(
      date
    );
    let CurrentDateTime = `${year}${month}${day}${randomnumber}${hours}${minutes}${seconds}`;

    const formData = new FormData();
    formData.append("email", studentQueryFormData.get("email"));
    formData.append("area", studentQueryFormData.get("area"));
    formData.append("fullName", studentQueryFormData.get("fullName"));
    formData.append("pincode", studentQueryFormData.get("pincode"));
    formData.append("course", studentQueryFormData.get("course"));
    formData.append("subject", studentQueryFormData.get("subject"));
    formData.append("classMode", studentQueryFormData.get("classMode"));
    formData.append("city", studentQueryFormData.get("city"));
    formData.append("mobile", studentQueryFormData.get("mobile"));
    formData.append("token", CurrentDateTime);
    formData.append("smsType", "generalQuery");
    formData.append("smsId", smsIdNew);
    formData.append("smsOtp", otpNew);
    setStudentQueryFormData(formData);

    try {
      const response = await axios.post(
        "https://app.kanhahometutions.com/api/v2/verifyOtp",
        formData
      );

      if (response.data.success.toString() === "true") {
        toast.success(response.data.message);
        setOpenOtpNew(false);
        setSmsIdNew(response.data.data.smsID.toString());
        setLoading(false);
        setOtpNew("");
      } else {
        toast.error(response.data.message ?? "OTP does not match.");
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data.message);
      setLoading(false);
    }
  };

  const [secondDropdownOpen, setSecondDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setSecondDropdownOpen((prevState) => !prevState);
  };

  const [secondDropdownOpen2, setSecondDropdownOpen2] = useState(false);
  const toggleDropdown2 = () => {
    setSecondDropdownOpen2((prevState) => !prevState);
  };

  const [selectedCity, setSelectedCity] = useState("");

  return (
    <>
      <div
        style={{
          display: isXs ? "flex" : "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          width: isXs ? "100%" : "100%",
          height: "90px",
          backgroundColor: "#F6EBDC",
          alignItems: "center",
          padding: isXs ? "1rem 2rem 1rem 6rem" : "1rem 1rem",
        }}
      >
        <a href="/">
          <img width={160} src={navlogo} alt="Logo" />
        </a>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: isXs ? "10px" : "30px",
          }}
        >
          <button
            style={{
              border: "none",
              backgroundColor: "#C68863",
              padding: "0",
              fontSize: "1rem",
              fontWeight: "500",
              display: isXs ? "" : "none",
              color: "white",
              padding: "9px 18px",
              borderRadius: "10px",
            }}
          >
            <Link
              to="/online-tuition-classes"
              style={{
                color: "white",
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Online Coaching
            </Link>
          </button>

          <button
            style={{
              border: "none",
              backgroundColor: "#C68863",
              padding: "0",
              fontSize: "1rem",
              fontWeight: "500",
              display: isXs ? "" : "none",
              color: "white",
              padding: "9px 18px",
              borderRadius: "10px",
            }}
          >
            <Link
              to="https://testseries.kanhahometutions.com/"
              style={{
                color: "white",
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Test Series
            </Link>
          </button>

          <div
            style={{
              display: isXs ? "flex" : "none",
              fontWeight: "500",
              fontSize: "1rem",
            }}
          >
            {" "}
            <a style={{ color: "black", textDecoration: "none" }} href="/">
              Home
            </a>
          </div>
          <div>
            <a
              style={{
                display: isXs ? "flex" : "none",
                textDecoration: "none",
                color: "black",
                fontSize: "16px",
                fontWeight: "500",
              }}
              href="/study-material"
            >
              Study Material
            </a>
          </div>

          <div style={{ display: isXs ? "" : "none" }}>
            <div className="dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  backgroundColor: "#F6EBDC",
                  color: "black",
                  fontWeight: "500",
                  border: "none",
                }}
              >
                Home Tutors in Your City
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                {/* Jaipur Dropdown */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Jaipur
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="home-tutors-in-jaipur">
                        Home Tutors in Jaipur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tutor-in-jaipur"
                      >
                        IIT-JEE Home Tutor in Jaipur
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="cbse-tutors-in-jaipur">
                        CBSE Tutors in Jaipur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-tutors-in-jaipur"
                      >
                        Mathematics Tutors in Jaipur
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Delhi Dropdown */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Delhi
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="home-tutors-in-delhi">
                        Home Tutors in Delhi
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tutor-in-delhi"
                      >
                        IIT-JEE Home Tutor in Delhi
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="cbse-tutors-in-delhi">
                        CBSE Tutors in Delhi
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-tutors-in-delhi"
                      >
                        Mathematics Tutors in Delhi
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Gurgaon Dropdown */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Gurgaon
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tutors-in-gurgaon"
                      >
                        Home Tutors in Gurgaon
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tutor-in-gurgaon"
                      >
                        IIT-JEE Home Tutor in Gurgaon
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-tutors-in-gurgaon"
                      >
                        CBSE Tutors in Gurgaon
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-tutors-in-gurgaon"
                      >
                        Mathematics Tutors in Gurgaon
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Bangalore */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Bangalore
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-bangalore"
                      >
                        Home Tuitions in Bangalore
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-bangalore"
                      >
                        IIT-JEE Home Tuition in Bangalore
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tutors-in-bangalore"
                      >
                        CBSE Home Tutors in Bangalore
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-tutors-in-bangalore"
                      >
                        Mathematics Tutors in Bangalore
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Mumbai */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Mumbai
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-mumbai"
                      >
                        Home Tuition in Mumbai
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-tuitions-in-mumbai"
                      >
                        IIT-JEE Tuitions in Mumbai
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tutors-in-mumbai"
                      >
                        CBSE Home Tutors in Mumbai
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-tuition-in-mumbai"
                      >
                        Mathematics Tutors in Mumbai
                      </a>
                    </li>
                  </ul>
                </li>

                {/*Ahmedabad */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Ahmedabad
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-ahmedabad"
                      >
                        Home Tuition in Ahmedabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-ahmedabad"
                      >
                        IIT-JEE Tuition in Ahmedabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tuition-in-ahmedabad"
                      >
                        CBSE Home Tuition in Ahmedabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tutor-in-ahmedabad"
                      >
                        Mathematics Tuition Ahmedabad
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Pune */}
                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Pune
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="home-tuition-in-pune">
                        Home Tuition in Pune
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-pune"
                      >
                        IIT-JEE Home Tuition in Pune
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tutors-in-pune"
                      >
                        CBSE Home Tutors in Pune
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tutors-in-pune"
                      >
                        Mathematics Home Tutors in Pune
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Nagpur
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-nagpur"
                      >
                        Home Tuition in Nagpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-nagpur"
                      >
                        IIT-JEE Home Tuition in Nagpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tuition-in-nagpur"
                      >
                        CBSE Home Tuition in Nagpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tuition-in-nagpur"
                      >
                        Mathematics Home Tuition in Nagpur
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Kanpur
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-kanpur"
                      >
                        Home Tuition in Kanpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-kanpur"
                      >
                        IIT-JEE Home Tuition in Kanpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tuition-in-kanpur"
                      >
                        CBSE Home Tuition in Kanpur
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tuition-in-kanpur"
                      >
                        Mathematics Home Tuition in Kanpur
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Lucknow
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-lucknow"
                      >
                        Home Tuition in Lucknow
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-lucknow"
                      >
                        IIT-JEE Home Tuition in Lucknow
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tuition-in-lucknow"
                      >
                        CBSE Home Tuition in Lucknow
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tuition-in-lucknow"
                      >
                        Mathematics Home Tuition in Lucknow
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Ghaziabad
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="home-tuition-in-ghaziabad"
                      >
                        Home Tuition in Ghaziabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="iit-jee-home-tuition-in-ghaziabad"
                      >
                        IIT-JEE Home Tuition in Ghaziabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="cbse-home-tuition-in-ghaziabad"
                      >
                        CBSE Home Tuition in Ghaziabad
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mathematics-home-tuition-in-ghaziabad"
                      >
                        Mathematics Home Tuition Ghaziabad
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Jhansi
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-jhansi"
                      >
                        Home Tuition in Jhansi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-jhansi"
                      >
                        IIT-JEE Home Tuition in Jhansi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-jhansi"
                      >
                        CBSE Home Tuition in Jhansi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-jhansi"
                      >
                        Mathematics Home Tuition in Jhansi
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Agra
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-agra"
                      >
                        Home Tuition in Agra
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-agra"
                      >
                        IIT-JEE Home Tuition in Agra
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-agra"
                      >
                        CBSE Home Tuition in Agra
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-agra"
                      >
                        Mathematics Home Tuition in Agra
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Bareilly
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-bareilly"
                      >
                        Home Tuition in Bareilly
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-bareilly"
                      >
                        IIT-JEE Home Tuition in Bareilly
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-bareilly"
                      >
                        CBSE Home Tuition in Bareilly
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-bareilly"
                      >
                        Mathematics Home Tuition in Bareilly
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Bhopal
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-bhopal"
                      >
                        Home Tuition in Bhopal
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-bhopal"
                      >
                        IIT-JEE Home Tuition in Bhopal
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-bhopal"
                      >
                        CBSE Home Tuition in Bhopal
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-bhopal"
                      >
                        Mathematics Home Tuition in Bhopal
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Indore
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-indore"
                      >
                        Home Tuition in Indore
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-indore"
                      >
                        IIT-JEE Home Tuition in Indore
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-indore"
                      >
                        CBSE Home Tuition in Indore
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-indore"
                      >
                        Mathematics Home Tuition in Indore
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Kolkata
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tutor-in-kolkata"
                      >
                        Home Tutor in Kolkata
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-kolkata"
                      >
                        IIT-JEE Home Tuition in Kolkata
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-kolkata"
                      >
                        CBSE Home Tuition in Kolkata
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-kolkata"
                      >
                        Mathematics Home Tuition in Kolkata
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Goa
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="/home-tuition-in-goa">
                        Home Tuition in Goa
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-goa"
                      >
                        IIT-JEE Home Tuition in Goa
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-goa"
                      >
                        CBSE Home Tuition in Goa
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-goa"
                      >
                        Mathematics Home Tuition in Goa
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Dehradun
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-dehradun"
                      >
                        Home Tuition in Dehradun
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-dehradun"
                      >
                        IIT-JEE Home Tuition in Dehradun
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-dehradun"
                      >
                        CBSE Home Tuition in Dehradun
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-dehradun"
                      >
                        Mathematics Home Tuition in Dehradun
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Ranchi
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-ranchi"
                      >
                        Home Tuition in Ranchi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-ranchi"
                      >
                        IIT-JEE Home Tuition in Ranchi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-ranchi"
                      >
                        CBSE Home Tuition in Ranchi
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-ranchi"
                      >
                        Mathematics Home Tuition in Ranchi
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Jalandhar
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-jalandhar"
                      >
                        Home Tuition in Jalandhar
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-jalandhar"
                      >
                        IIT-JEE Home Tuition in Jalandhar
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-jalandhar"
                      >
                        CBSE Home Tuition in Jalandhar
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-jalandhar"
                      >
                        Mathematics Home Tuition in Jalandhar
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="dropdown-submenu position-relative">
                  <div
                    className="dropdown-item dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Panchkula
                    <div>
                      <PlayArrowIcon style={{ fontSize: "12px" }} />
                    </div>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/home-tuition-in-panchkula"
                      >
                        Home Tuition in Panchkula
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/iit-jee-home-tuition-in-panchkula"
                      >
                        IIT-JEE Home Tuition in Panchkula
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/cbse-home-tuition-in-panchkula"
                      >
                        CBSE Home Tuition in Panchkula
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/mathematics-home-tuition-in-panchkula"
                      >
                        Mathematics Home Tuition in Panchkula
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              padding: "0",
              fontSize: "1rem",
              fontWeight: "500",
              display: isXs ? "" : "none",
            }}
          >
            <Link
              to="/signin-teacher"
              style={{
                color: "black",
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Login as Tutor
            </Link>
          </button>

          <div style={{ position: "relative" }}>
            <div
              onClick={toggleMenu}
              style={{
                cursor: "pointer",
                fontSize: "1rem",
                fontWeight: "500",
                display: isXs ? "flex" : "none",
              }}
            >
              <MenuIcon />
            </div>
            {Menu && (
              <div
                ref={menuRef}
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  borderRadius: "5px",
                  minWidth: "250px",
                  backgroundColor: "white",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  zIndex: 1000,
                }}
              >
                <div style={{ padding: "15px 0px" }}>
                  <div style={{ padding: "0.3rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/student-signin"
                    >
                      Login as Student
                    </a>
                  </div>

                  <div>
                    <div
                      style={{
                        padding: "0.3rem 1rem",
                        fontSize: "16px",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                        fontFamily: "jost",
                      }}
                      onClick={toggleDropdown2}
                    >
                      Online Courses
                      {secondDropdownOpen2 ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      )}
                    </div>
                    <Collapse
                      in={secondDropdownOpen2}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List
                        style={{ paddingLeft: "10px" }}
                        component="div"
                        disablePadding
                      >
                        <div
                          style={{
                            padding: "0.3rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            cursor: "pointer",
                            color: "black",
                          }}
                          onClick={handleOpen}
                        >
                          Online class IIT-JEE maths
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class IIT-JEE physics
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            paddingBottom: "0.3rem",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class IIT-JEE chemistry
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class NEET physics
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class NEET chemistry
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class NEET biology
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class 12th maths CBSE
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class 12th physics
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class 12th chemistry
                        </div>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Online class 12th biology
                        </div>
                      </List>
                    </Collapse>
                  </div>

                  <div>
                    <div
                      style={{
                        padding: "0.3rem 1rem",
                        fontSize: "16px",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                        fontFamily: "jost",
                      }}
                      onClick={toggleDropdown}
                    >
                      One to One Class
                      {secondDropdownOpen ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      )}
                    </div>
                    <Collapse
                      in={secondDropdownOpen}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List
                        style={{ paddingLeft: "10px" }}
                        component="div"
                        disablePadding
                      >
                        <ListItem disablePadding>
                          <div
                            style={{
                              padding: "0.3rem 1rem",
                              fontSize: "12px",
                              fontFamily: "jost",
                              cursor: "pointer",
                              color: "black",
                            }}
                            onClick={handleOpen}
                          >
                            Online Tuition{" "}
                          </div>
                        </ListItem>
                        <ListItem disablePadding>
                          <div
                            style={{
                              padding: "0.2rem 1rem",
                              fontSize: "12px",
                              fontFamily: "jost",
                              color: "black",
                              cursor: "pointer",
                            }}
                            onClick={handleOpen}
                          >
                            {" "}
                            Home Tuition
                          </div>
                        </ListItem>
                        <div
                          style={{
                            padding: "0.2rem 1rem",
                            fontSize: "12px",
                            fontFamily: "jost",
                            color: "black",
                            paddingBottom: "0.3rem",
                            cursor: "pointer",
                          }}
                          onClick={handleOpen}
                        >
                          Hire a Personal Tutor
                        </div>
                      </List>
                    </Collapse>
                  </div>
                  <div style={{ padding: "0.3rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/for-student"
                    >
                      For Student
                    </a>
                  </div>
                  <div></div>
                  <div style={{ padding: "0.3rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/for-teacher"
                    >
                      For Teacher
                    </a>
                  </div>
                  <div style={{ padding: "0.2rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/teacher-job"
                    >
                      Post a Teacher Job
                    </a>
                  </div>
                  <div style={{ padding: "0.2rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/contact-us"
                    >
                      Contact Us
                    </a>
                  </div>
                  <div style={{ padding: "0.2rem 1rem", fontSize: "16px" }}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        fontFamily: "jost",
                      }}
                      href="/about-us"
                    >
                      About Us
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{ position: "relative" }}>
            <div onClick={toggleBox}>
              <MenuIcon
                style={{
                  display: isXs ? "none" : "flex",
                  fontSize: "40px",
                  color: "#CB8B65",
                }}
              />
            </div>
            {isOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "40px",
                  right: "-16px",
                  backgroundColor: "white",
                  zIndex: 15,
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  minWidth: "100vw",
                  padding: "15px 0px 40px 0px",
                  overflow: "hidden",
                  marginTop: "25px",
                  transition: `height 0.3s ease, opacity 0.3s ease`,
                  height: dropdownHeight,
                  opacity: isOpen ? 1 : 0,
                }}
                id="dropdownContent"
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexDirection: "column",
                    justifyContent: "center",
                    marginLeft: "0rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "1.2rem",
                      alignItems: "center",
                      padding: "0rem 0rem",
                      marginBottom: ".6rem",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#CB8B65",
                        padding: ".5rem 1rem",
                        borderRadius: "20px",
                      }}
                    >
                      <Link
                        to="/student-signin"
                        style={{
                          textDecoration: "none",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        Login as Student
                      </Link>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#CB8B65",
                        padding: ".5rem 1rem",
                        borderRadius: "20px",
                      }}
                    >
                      <Link
                        to="/signin-teacher"
                        style={{
                          textDecoration: "none",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        Login as Tutor
                      </Link>
                    </div>
                  </div>

                  <div
                    style={{
                      height: "2px",
                      width: "100%",
                      backgroundColor: "#FFDB7E",
                      marginBottom: "10px",
                    }}
                  ></div>
                  <div
                    style={{
                      marginLeft: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: isXs ? "none" : "flex",
                        fontWeight: "500",
                        fontSize: "16px",
                      }}
                    >
                      {" "}
                      <a
                        style={{ color: "black", textDecoration: "none" }}
                        href="/"
                      >
                        Home
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />
                    <div>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/study-material"
                      >
                        Study Material
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />
                    <List sx={{ padding: "0px 0px" }}>
                      <ListItem
                        sx={{
                          padding: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        disablePadding
                        onClick={handleClickDropdown}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontFamily: "jost",
                            fontSize: "16px",
                            fontWeight: "500",
                            marginBottom: "-6px",
                          }}
                          primary="Home Tutors in Your City"
                        />
                        <div style={{ paddingRight: "40px" }}>
                          {openDropdown ? (
                            <RemoveIcon />
                          ) : (
                            <AddIcon sx={{ fontSize: "19px" }} />
                          )}
                        </div>
                      </ListItem>

                      <Collapse in={openDropdown} timeout="auto" unmountOnExit>
                        <List
                          style={{ padding: "0px 20px" }}
                          component="div"
                          disablePadding
                        >
                          {/* Jaipur */}
                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Jaipur" ? null : "Jaipur"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Jaipur"
                            />
                            {selectedCity === "Jaipur" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Jaipur"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tutors-in-jaipur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Jaipur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tutor-in-jaipur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tutor in Jaipur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-tutors-in-jaipur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Jaipur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-tutors-in-jaipur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Jaipur"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          {/* Delhi */}
                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Delhi" ? null : "Delhi"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Delhi"
                            />
                            {selectedCity === "Delhi" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Delhi"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tutors-in-delhi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Delhi"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tutor-in-delhi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tutor in Delhi"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-tutors-in-delhi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Delhi"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-tutors-in-delhi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Delhi"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          {/* Gurgaon */}
                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Gurgaon" ? null : "Gurgaon"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Gurgaon"
                            />
                            {selectedCity === "Gurgaon" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Gurgaon"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tutors-in-gurgaon"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Gurgaon"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tutor-in-gurgaon"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tutor in Gurgaon"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-tutors-in-gurgaon"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Gurgaon"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-tutors-in-gurgaon"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Gurgaon"
                                />
                              </a>
                            </ListItem>
                          </Collapse>
                          {/* Gurgaon */}

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Bangalore"
                                  ? null
                                  : "Bangalore"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Bangalore"
                            />
                            {selectedCity === "Bangalore" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Bangalore"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-bangalore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Bangalore"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-bangalore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Bangalore"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tutors-in-bangalore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Bangalore"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-tutors-in-bangalore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Bangalore"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Pune" ? null : "Pune"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Pune"
                            />
                            {selectedCity === "Pune" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Pune"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-pune"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Pune"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-pune"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Pune"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tutors-in-pune"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Pune"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tutors-in-pune"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tutors in Pune"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Mumbai" ? null : "Mumbai"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Mumbai"
                            />
                            {selectedCity === "Mumbai" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Mumbai"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-mumbai"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Mumbai"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-tuitions-in-mumbai"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tutor in Mumbai"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tutors-in-mumbai"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Mumbai"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-tuition-in-mumbai"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Mumbai"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Ahmedabad"
                                  ? null
                                  : "Ahmedabad"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Ahmedabad"
                            />
                            {selectedCity === "Ahmedabad" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>
                          <Collapse
                            in={selectedCity === "Ahmedabad"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-ahmedabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Ahmedabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-ahmedabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tutor in Ahmedabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tuition-in-ahmedabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tutors in Ahmedabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tutor-in-ahmedabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Ahmedabad"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Hyderabad"
                                  ? null
                                  : "Hyderabad"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Hyderabad"
                            />
                            {selectedCity === "Hyderabad" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Hyderabad"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuitions-in-hyderabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Hyderabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-hyderabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Hyderabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tutors-in-hyderabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Tutors in Hyderabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tutors-in-hyderabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Tutors in Hyderabad"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Nagpur" ? null : "Nagpur"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Nagpur"
                            />
                            {selectedCity === "Nagpur" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Nagpur"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-nagpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Nagpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-nagpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Nagpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tuition-in-nagpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Nagpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tuition-in-nagpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Nagpur"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Kanpur" ? null : "Kanpur"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Kanpur"
                            />
                            {selectedCity === "Kanpur" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Kanpur"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-kanpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutors in Kanpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-kanpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Kanpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tuition-in-kanpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tutors in Kanpur"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tuition-in-kanpur"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tutors in Kanpur"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Lucknow" ? null : "Lucknow"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Lucknow"
                            />
                            {selectedCity === "Lucknow" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Lucknow"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-lucknow"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Lucknow"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-lucknow"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Lucknow"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tuition-in-lucknow"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tutors in Lucknow"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tuition-in-lucknow"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tutors in Lucknow"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          {/* Surat */}

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Surat" ? null : "Surat"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Surat"
                            />
                            {selectedCity === "Surat" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Surat"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="home-tuition-in-surat"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Surat"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="iit-jee-home-tuition-in-surat"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT-JEE Home Tuition in Surat"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="cbse-home-tuition-in-surat"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Surat"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="mathematics-home-tuition-in-surat"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Surat "
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Ghaziabad"
                                  ? null
                                  : "Ghaziabad"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Ghaziabad"
                            />
                            {selectedCity === "Ghaziabad" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Ghaziabad"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="/home-tuition-in-ghaziabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Ghaziabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="/iit-jee-home-tuition-in-ghaziabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Ghaziabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="/cbse-home-tuition-in-ghaziabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Ghaziabad"
                                />
                              </a>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                href="/mathematics-home-tuition-in-ghaziabad"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Ghaziabad"
                                />
                              </a>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Jhansi" ? null : "Jhansi"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Jhansi"
                            />
                            {selectedCity === "Jhansi" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Jhansi"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-jhansi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Jhansi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-jhansi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Jhansi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-jhansi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Jhansi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-jhansi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Jhansi"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Agra" ? null : "Agra"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Agra"
                            />
                            {selectedCity === "Agra" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Agra"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-agra"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Agra"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-agra"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Agra"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-agra"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Agra"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-agra"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Agra"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Bareilly" ? null : "Bareilly"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Bareilly"
                            />
                            {selectedCity === "Bareilly" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Bareilly"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-bareilly"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Bareilly"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-bareilly"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Bareilly"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-bareilly"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Bareilly"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-bareilly"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Bareilly"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Bhopal" ? null : "Bhopal"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Bhopal"
                            />
                            {selectedCity === "Bhopal" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Bhopal"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-bhopal"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Bhopal"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-bhopal"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Bhopal"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-bhopal"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Bhopal"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-bhopal"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Bhopal"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Indore" ? null : "Indore"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Indore"
                            />
                            {selectedCity === "Indore" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Indore"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-indore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Indore"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-indore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Indore"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-indore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Indore"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-indore"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Indore"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Kolkata" ? null : "Kolkata"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Kolkata"
                            />
                            {selectedCity === "Kolkata" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Kolkata"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tutor-in-kolkata"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tutor in Kolkata"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-kolkata"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Kolkata"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-kolkata"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Kolkata"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tution-in-kolkata"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Kolkata"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Goa" ? null : "Goa"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Goa"
                            />
                            {selectedCity === "Goa" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Goa"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-goa"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Goa"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-goa"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Goa"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-goa"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Goa"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-goa"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Goa"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Dehradun" ? null : "Dehradun"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Dehradun"
                            />
                            {selectedCity === "Dehradun" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Dehradun"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-dehradun"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Dehradun"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-dehradun"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Dehradun"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-dehradun"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Dehradun"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-dehradun"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Dehradun"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Ranchi" ? null : "Ranchi"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Ranchi"
                            />
                            {selectedCity === "Ranchi" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Ranchi"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-ranchi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Ranchi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-ranchi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Ranchi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-ranchi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Ranchi"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-ranchi"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Ranchi"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Jalandhar"
                                  ? null
                                  : "Jalandhar"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Jalandhar"
                            />
                            {selectedCity === "Jalandhar" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Jalandhar"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-jalandhar"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Jalandhar"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-jalandhar"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Jalandhar"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-jalandhar"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Jalandhar"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-jalandhar"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Jalandhar"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>

                          <ListItem
                            disablePadding
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              setSelectedCity(
                                selectedCity === "Panchkula"
                                  ? null
                                  : "Panchkula"
                              )
                            }
                          >
                            <ListItemText
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Panchkula"
                            />
                            {selectedCity === "Panchkula" ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon sx={{ fontSize: "19px" }} />
                            )}
                          </ListItem>

                          <Collapse
                            in={selectedCity === "Panchkula"}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ListItem
                              disablePadding
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                              }}
                            >
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/home-tuition-in-panchkula"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Home Tuition in Panchkula"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/iit-jee-home-tuition-in-panchkula"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="IIT JEE Home Tuition in Panchkula"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/cbse-home-tuition-in-panchkula"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="CBSE Home Tuition in Panchkula"
                                />
                              </Link>
                              <Link
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                to="/mathematics-home-tuition-in-panchkula"
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontFamily: "jost",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                  primary="Mathematics Home Tuition in Panchkula"
                                />
                              </Link>
                            </ListItem>
                          </Collapse>
                        </List>
                      </Collapse>
                    </List>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <List sx={{ padding: "0px 0px" }}>
                      <ListItem
                        sx={{ padding: "0px", justifyContent: "space-between" }}
                        disablePadding
                        onClick={handleClickDropdownNew}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontFamily: "jost",
                            fontSize: "16px",
                            fontWeight: "500",
                            marginBottom: "-6px",
                          }}
                          primary="Online Courses"
                        />
                        <div style={{ paddingRight: "40px" }}>
                          {openDropdownNew ? (
                            <RemoveIcon />
                          ) : (
                            <AddIcon sx={{ fontSize: "19px" }} />
                          )}
                        </div>
                      </ListItem>
                      <Collapse
                        in={openDropdownNew}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List
                          onClick={handleOpen}
                          style={{ paddingLeft: "20px" }}
                          component="div"
                          disablePadding
                        >
                          {[
                            "IIT-JEE maths",
                            "IIT-JEE physics",
                            "IIT-JEE chemistry",
                            "NEET physics",
                            "NEET chemistry",
                            "NEET biology",
                            "12th maths CBSE",
                            "12 physics",
                            "12 chemistry",
                            "12 biology",
                          ].map((course) => (
                            <ListItem disablePadding key={course}>
                              <ListItemText
                                primaryTypographyProps={{
                                  fontFamily: "jost",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                                primary={`Online class ${course}`}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </List>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <List sx={{ padding: "0px 0px" }}>
                      <ListItem
                        sx={{
                          padding: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        disablePadding
                        onClick={handleClickDropdownCity}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontFamily: "jost",
                            fontSize: "16px",
                            fontWeight: "500",
                            marginBottom: "-6px",
                          }}
                          primary="One to One Class"
                        />
                        <div style={{ paddingRight: "40px" }}>
                          {openDropdownCity ? (
                            <RemoveIcon />
                          ) : (
                            <AddIcon sx={{ fontSize: "19px" }} />
                          )}
                        </div>
                      </ListItem>

                      <Collapse
                        in={openDropdownCity}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List
                          style={{ paddingLeft: "20px" }}
                          component="div"
                          disablePadding
                        >
                          <ListItem disablePadding>
                            <ListItemText
                              onClick={handleOpen}
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Online Tuition"
                            />
                          </ListItem>
                          <ListItem disablePadding>
                            <ListItemText
                              onClick={handleOpen}
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Home Tuition"
                            />
                          </ListItem>
                          <ListItem disablePadding>
                            <ListItemText
                              onClick={handleOpen}
                              primaryTypographyProps={{
                                fontFamily: "jost",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                              primary="Hire a Personal Tutor"
                            />
                          </ListItem>
                        </List>
                      </Collapse>
                    </List>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div style={{}}>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/for-student"
                      >
                        For Student
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div style={{}}>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/for-teacher"
                      >
                        For Teacher
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div style={{}}>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/teacher-job"
                      >
                        Post a Teacher Job
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/contact-us"
                      >
                        Contact Us
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />
                    <div>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/about-us"
                      >
                        About Us
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="/online-tuition-classes"
                      >
                        Online Coaching
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />

                    <div>
                      <a
                        style={{
                          textDecoration: "none",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        href="https://testseries.kanhahometutions.com/"
                      >
                        Test Series
                      </a>
                    </div>
                    <hr style={{ padding: "0px", margin: "0px" }} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Dialog
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        onClose={handleClose("backdropClick")}
        open={open}
        sx={{
          overflow: isXs ? "" : "auto",
          "& .MuiDialog-paper": {
            width: isXs ? "38%" : "600px",
            maxWidth: "none",
          },
        }}
      >
        <div
          className="modal-content"
          style={{
            marginTop: isXs ? "" : "0%",
            textAlign: isXs ? "" : "center",
            width: isXs ? "100%" : "100%",
          }}
        >
          <Button
            style={{
              position: "absolute",
              right: "0%",
              backgroundColor: "white",
              borderRadius: "100%",
              minWidth: "2rem",
              color: "black",
            }}
            onClick={() => handleClose("close")}
          >
            X
          </Button>
          <div
            className="text-center py-2 fw-bold"
            style={{
              backgroundColor: "#CB8B65",
              width: "100%",
              fontSize: isXs ? "28px" : "22px",
              marginBottom: "5%",
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            <div
              style={{
                color: "#FFDB7E",
              }}
            >
              FREE
            </div>
            <div
              style={{
                color: "white",
              }}
            >
              REGISTRATION
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Box
              className="d-flex justify-content-center mt-2"
              component="form"
              sx={{
                "& .MuiTextField-root": {
                  m: 1,
                  width: isXs ? "23ch" : "75%",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "0.5px",
                },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <div style={{ textAlign: isXs ? "end" : "center" }}>
                    <TextField
                      {...register("fullName")}
                      name="fullName"
                      id="fullName"
                      label="Full Name"
                      type="text"
                      placeholder="Enter your Full Name"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setFullName(e.target.value)
                      // }
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginRight: isXs ? "12%" : "",
                      }}
                    >
                      {errors.fullName?.message}
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <div>
                    <TextField
                      {...register("mobileNumber")}
                      name="mobileNumber"
                      id="mobileNumber"
                      label="Mobile Number"
                      type="number"
                      placeholder="Enter your Mobile Number"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setMobileNumber(e.target.value)
                      // }
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginLeft: isXs ? "5%" : "",
                      }}
                    >
                      {errors.mobileNumber?.message}
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
            <Box
              className="d-flex  mt-1 justify-content-between "
              component="form"
              sx={{
                "& .MuiTextField-root": {
                  m: 1,
                  width: isXs ? "23ch" : "75%",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "0.5px",
                },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <div style={{ textAlign: isXs ? "end" : "center" }}>
                    <TextField
                      {...register("email")}
                      name="email"
                      id="email"
                      label="Email"
                      type='"email'
                      placeholder="Enter your Email"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      style={{ marginLeft: "3%" }}
                      // onChange={(e) =>
                      //     setEmail(e.target.value)
                      // }
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginRight: isXs ? "20%" : "",
                      }}
                    >
                      {errors.email?.message}
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <FormControl
                    component="fieldset"
                    style={{ marginLeft: "4%" }}
                  >
                    <FormLabel
                      component="legend"
                      style={{
                        marginBottom: "0%",
                        fontSize: isXs ? "0.9vw" : "3vw",
                        color: "black",
                        letterSpacing: "0px",
                      }}
                    >
                      Mode of Classes*
                    </FormLabel>
                    <Controller
                      // rules={{ required: true }}
                      control={control}
                      name="classMode"
                      render={({ field }) => (
                        <RadioGroup
                          row
                          aria-label="position"
                          {...field}
                          name="position"
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio color="primary" />}
                            label={
                              <span
                                style={{
                                  fontSize: isXs ? "1vw" : "3vw",
                                }}
                              >
                                Online
                              </span>
                            }
                          />
                          <FormControlLabel
                            value="0"
                            control={<Radio color="primary" />}
                            label={
                              <span
                                style={{
                                  fontSize: isXs ? "1vw" : "3vw",
                                }}
                              >
                                Offine
                              </span>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              className="d-flex justify-content-center mt-1"
              component="form"
              sx={{
                "& .MuiTextField-root": {
                  m: 1,
                  width: isXs ? "23ch" : "75%",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "0.5px",
                },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <div style={{ textAlign: isXs ? "end" : "center" }}>
                    <TextField
                      name="ccb"
                      id="ccb"
                      label="Course / Class/ Board"
                      type='"text'
                      placeholder="Enter Course You Need"
                      {...register("course")}
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setCource(e.target.value)
                      // }
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginRight: isXs ? "17%" : "",
                      }}
                    >
                      {errors.course?.message}
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <div>
                    <TextField
                      name="subject"
                      {...register("subject")}
                      id="subject"
                      label="Subject"
                      type="text"
                      placeholder="Enter Subject You Need"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setSubject(e.target.value)
                      // }
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginLeft: isXs ? "5%" : "",
                      }}
                    >
                      {errors.subject?.message}
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
            <Box
              className="d-flex justify-content-center mt-1"
              component="form"
              sx={{
                "& .MuiTextField-root": {
                  m: 1,
                  width: isXs ? "13.8ch" : "75%",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderWidth: isXs ? "2px" : "2px",
                },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                  <div style={{ textAlign: isXs ? "end" : "center" }}>
                    <TextField
                      {...register("city")}
                      name="city"
                      id="city"
                      label="City"
                      type='"text'
                      placeholder="Enter City Name"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setCity(e.target.value)
                      // }
                    />
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.city?.message}
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                  <div style={{ textAlign: "center" }}>
                    <TextField
                      {...register("area")}
                      name="area"
                      id="area"
                      label="Area"
                      type="text"
                      placeholder="Enter Area Name"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setArea(e.target.value)
                      // }
                    />
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.area?.message}
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                  <div tyle={{ textAlign: "start" }}>
                    <TextField
                      {...register("pincode")}
                      name="pincode"
                      id="pincode"
                      label="Pincode"
                      type="text"
                      placeholder="Enter Pincode"
                      required
                      inputProps={{
                        style: {
                          height: "10px",
                          fontSize: "12px",
                        },
                      }}
                      InputLabelProps={{
                        sx: { color: "black" },
                      }}
                      color="grey"
                      focused
                      // onChange={(e) =>
                      //     setPincode(e.target.value)
                      // }
                    />
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.pincode?.message}
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
            <div className="d-flex justify-content-center my-2">
              {/* <button type="submit" className="btn btn-primary py-2 w-75 fw-bold" style={{ fontSize: '14px', border: '1px solid #CB8B65', backgroundColor: '#FFDB7E', color: '#866D2C', borderRadius: '0', zIndex: 3 }}>Get Free Demo Class</button> */}

              {loading ? (
                <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                  <CircularProgress color="success" />
                </Stack>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary py-2 w-75 fw-bold"
                  style={{
                    fontSize: "14px",
                    border: "1px solid #CB8B65",
                    backgroundColor: "#FFDB7E",
                    color: "#866D2C",
                    borderRadius: "0",
                  }}
                >
                  Next
                </button>
              )}
            </div>
          </form>
          <div
            style={{
              height: "40px",
              textAlign: "center",
              alignItems: "center",
              padding: "10px 0px",
            }}
          >
            {" "}
            <span style={{ fontWeight: "700", fontSize: "14px" }}>
              Are you a Tutor?
            </span>{" "}
            <a href="/signup-teacher">
              <span style={{ fontSize: "14px", fontWeight: "700" }}>
                Create Free Profile
              </span>
            </a>
          </div>

          <div className="d-flex flex-row justify-content-between w-full mb-3">
            <div
              className="flex-grow-1 text-center"
              style={{
                fontSize: "12px",
                fontWeight: "900",
              }}
            >
              <small className="block">
                <span className="">By signing up you agree to our </span>
                <a href="/terms-conditions" style={{ color: "#0582D2" }}>
                  {" "}
                  Terms and Conditions
                </a>
              </small>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={openOtpNew}
        onClose={() => {}}
        maxWidth="md"
        sx={{
          "& .MuiBackdrop-root": {
            backdropFilter: "blur(1px)", // Apply blur effect directly
          },
        }}
        PaperProps={{
          sx: {
            padding: "rem",
            overflowX: "hidden",
          },
        }}
      >
        <Button
          onClick={handleCloseOtpNew}
          style={{
            position: "absolute",
            right: "0%",
            top: "0",
            backgroundColor: "white",
            borderRadius: "100%",
            minWidth: "2rem",
            color: "black",
            border: "1px solid black",
          }}
        >
          X
        </Button>

        <div style={{ padding: "1rem" }}>
          <form
            onSubmit={handleSubmitOtpNew}
            style={{ padding: isXs ? "0px 10px" : "0px 0px" }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ fontSize: "30px", textAlign: "center" }}>
                OTP Verification{" "}
              </div>

              <div style={{ textAlign: "center" }}>
                {" "}
                A One-Time Password has been sent to{" "}
                {studentQueryFormData
                  ? studentQueryFormData.get("mobile")
                  : null}
              </div>
              <div>
                <MuiOtpInput
                  style={{
                    width: isXs ? "400px" : "270px",
                    gap: isXs ? "20px" : "5px",
                    padding: "14px 3px",
                    alignItems: "center",
                    textAlign: "center",
                    display: "flex",
                    margin: "0px auto",
                  }}
                  value={otpNew}
                  onChange={handleChangeOtpNew}
                  length={6}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "20px",
                  gap: "10px",
                  flexDirection: isXs ? "" : "column",
                }}
              >
                <div style={{ textAlign: "center" }}>Didn’t Receive OTP?</div>
                {loading2 ? (
                  <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                    <CircularProgress color="success" />
                  </Stack>
                ) : (
                  <div
                    type="button"
                    style={{ color: "#cb8b65", textAlign: "center" }}
                    onClick={handleResendOtpNew}
                  >
                    Resend OTP
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "70px",
              }}
            >
              {loading ? (
                <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                  <CircularProgress color="success" />
                </Stack>
              ) : (
                <button
                  style={{
                    backgroundColor: "#CB8B65",
                    color: "white",
                    width: "30rem",
                    height: "2.5rem",
                    border: "none",
                    borderRadius: "3px",
                  }}
                >
                  Submit
                </button>
              )}
            </div>
          </form>
        </div>
      </Dialog>
    </>
  );
}

export default NavBar;
